import Vue from 'vue'

const url = 'jumblewords'
const jumblewords = {
  namespaced: true,
  state: {
    jumblewords: []
  },
  // CRUD / RESTful actions
  mutations: {
    SET(state, data) {
      state.jumblewords = data
    },
    NEW(state, data) {
      state.jumblewords.unshift(data)
    },
    UPD(state, data) {
      const index = state.jumblewords.findIndex(t => t.id == data)
      if(index !== -1) {
        state.jumblewords.splice(index, 1, data)
      }
    },
    DEL(state, data) {
      state.jumblewords = state.jumblewords.filter(jumblewords => jumblewords.id != data.id)
    }
  },
  actions: {
    async fetch({commit}) {
      const response = await Vue.prototype.$axios.get(url)
      commit('SET', response.data)
    },
    async create({commit}, jumbleword) {
      Vue.prototype.$axios.post(url, jumbleword).then(res => {
        Vue.prototype.$toastr.s('Created new Jumble Word.')
        commit('NEW', res.data)
      }).catch(err => {
        console.log(err)
        Vue.prototype.$toastr.e('Could note create Jumble Word.')
      })
    },
    async update({commit}, jumbleword) {
      Vue.prototype.$axios.put(url + '/' + jumbleword.id, jumbleword).then(res => {
        Vue.prototype.$toastr.s('Updated ' + jumbleword.name)
        commit('UPD', res.data)
      }).catch(err => {
        Vue.prototype.$toastr.e('Error.', err.data)
        console.log(err)
      })
    },
    async remove({commit}, jumbleword) {
      const response = await Vue.prototype.$axios.delete(url + '/' + jumbleword.id)
      Vue.prototype.$toastr.s('Deleted Jumble Word Successfully')
      commit('DEL', response.data)
    }
  },
  getters: {
    all: state => state.jumblewords,
    byClient:(state) => (id) => {
      return state.jumblewords.filter(jumbleword => {
        return jumbleword.client_id == id
      })
    }
  }
}

export default jumblewords